// Phase 10 — TemplatesPageRoute.
//
// Route-level wrapper for Signal & Chain Templates.

import { TemplatesPage } from "../../modes/templates/TemplatesPage.tsx";

export function TemplatesPageRoute(): JSX.Element {
  return <TemplatesPage />;
}
